import { env } from '../../../shared/utils/env';

export const getCountdown = (dateTime: Date, now: Date) => {
  const diffMs = Math.max(0, dateTime.getTime() - now.getTime());
  const totalMinutes = Math.floor(diffMs / 60_000);
  const atRiskThresholdMinutes =
    env.STAGING_BUFFER_MINUTES + env.AT_RISK_BUFFER_MINUTES;
  return {
    hours: Math.floor(totalMinutes / 60),
    minutes: totalMinutes % 60,
    isAtRisk: totalMinutes <= atRiskThresholdMinutes,
  };
};
